import React, { useState } from 'react';
import { RequiredFieldNotice } from '../basic/RequiredFieldNotice';
import { FormHeader } from '../basic/FormHeader';
import {
  ProfileEventTypes,
  useProfileUpComm
} from '../screens/Profile/ProfileData';
import { UserDataKeys } from '../screens/Profile/UserDataKeys';
import { LoginInput } from '../data-inputs/validated/LoginInput';
import { navigateTo } from '../../navigation/path-builder';
import { trackingClient, useTrackLoadUnload } from '../../ext/tracking';
import { EnterAwareButton } from '../magma-wrap/EnterAwareButton';
import { Marker } from '../meta/Marker';
import { DEV_HELP_GLOBAL } from '../../dev/dev-barrier/safe-ref';
import { getInstitutionById } from '../../api';
import { getUserNameFromQuery } from '../../signinWidgetUtils/widget-mod/url-util';

export const TEST_ID = {
  MARKER: 'marker-faculty-discover',
  ERR_TEST_ID: 'error-alert'
};

export interface FacultyDiscoverProps {}

export const FacultyDiscover: React.FC<FacultyDiscoverProps> = () => {
  const upComm = useProfileUpComm();
  const hasOverrides = !!upComm?.ctx?.overrides?.hidden?.[UserDataKeys.instId];
  const category = trackingClient.event.facultyDiscovery;
  useTrackLoadUnload(category);
  let username = getUserNameFromQuery();
  const isSubmitDisabled = () => !upComm.ctx.isValid && !(username.length > 0);

  const [_devOverride, _setDevOverride] = useState(
    undefined as undefined | any
  );

  const navigateWithInstitutionId = (username: string) => {
    const options = { username };
    if (upComm?.ctx?.overrides?.values?.[UserDataKeys.autoVerifyUser]) {
      navigateTo.facultyRegister.internationalFacultyCreateProfile(options);
    }
    else {
      const institutionId = upComm?.ctx?.overrides?.values?.[UserDataKeys.instId];
      getInstitutionById(institutionId).then((response) => {
        if (response && response.result && response.result.ok && response.body && !!response.body.autoVerify) {
          navigateTo.facultyRegister.facultyCreateProfile(options);
        } else {
          navigateTo.facultyRegister.internationalFacultyCreateProfile(options);
        }
      }).catch(err => {
        console.log(err);
        navigateTo.facultyRegister.internationalFacultyCreateProfile(options);
      });
    }
  };

  const discoverUser = async () => {
    upComm.sendMsg({
      type: ProfileEventTypes.discoverUsername,
      data: {
        _devOverride,
        whenNotActivating: async (userData: any) => {
          if (userData[UserDataKeys.login]) {
            username = userData[UserDataKeys.login];
          }
          if (hasOverrides) {
            navigateWithInstitutionId(username);
          } else {
            navigateTo.facultyRegister.facultyLanding({ username });
          }
        }
      }
    });
  };

  /* istanbul ignore next */
  window?.[DEV_HELP_GLOBAL]?.useCommand?.({
    id: 'sheer-id.discover.doc-upload',
    display: 'SheerID Discover Doc Upload',
    action: () => {
      _setDevOverride({
        getUserByEmail: async () => {
          return {
            found: true,
            activating: true,
            verificationData: '5f510a0c05abf2187356a994',
            verificationStatus: 'SHEERID_MANUAL_STARTED'
          };
        }
      });
    }
  });

  return (
    <>
      <Marker testId={TEST_ID.MARKER} />

      <FormHeader>Create Account</FormHeader>
      <RequiredFieldNotice />
      <LoginInput upComm={upComm}
        helperMessage={'Enter your institutional email. This will serve as your username.'}
        autoFocus defaultValue={username}/>

      <EnterAwareButton
        isFullWidth={true}
        testId="submit-button"
        id="submit-button"
        value="Next"
        disabled={isSubmitDisabled()}
        onClick={() => {
          category.nextButtonClick();
          discoverUser();
        }}
      />
    </>
  );
};